var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('myinfo-row', {
    attrs: {
      "label": _vm.label,
      "pointer": ""
    }
  }, [_c('v-row', _vm._l(_vm.areas_structured, function (parent) {
    return _c('v-col', {
      key: parent._id,
      attrs: {
        "cols": "6",
        "lg": ""
      }
    }, [_c('v-row', [_c('v-col', [_vm._v(_vm._s(parent.name))])], 1), _vm._l(parent.children, function (child) {
      return _c('v-row', {
        key: child._id
      }, [_c('v-col', [_c('v-checkbox', {
        staticClass: "my-0 py-0",
        attrs: {
          "label": child.name,
          "value": child._id,
          "hide-details": "",
          "dense": ""
        },
        on: {
          "input": _vm.syncInput,
          "change": _vm.syncInput
        },
        model: {
          value: _vm.input._areas,
          callback: function callback($$v) {
            _vm.$set(_vm.input, "_areas", $$v);
          },
          expression: "input._areas"
        }
      })], 1), child.name == '기타(입력)' && _vm.value._areas.includes(child._id) ? _c('v-col', {
        staticClass: "pt-0",
        attrs: {
          "cols": "12"
        }
      }, [_c('v-text-field', {
        staticClass: "my-0 py-0",
        attrs: {
          "value": _vm.findManualValue(parent),
          "hide-details": "",
          "dense": "",
          "outlined": ""
        },
        on: {
          "input": function input(name) {
            return _vm.syncManualInput(name, parent);
          }
        }
      })], 1) : _vm._e()], 1);
    })], 2);
  }), 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }